// Backing out of the extras modal right after adding a program: the days the
// program spread over (all but its first) are given back. Pure, out of the
// component (US-064): returns the days to write, or `null` when nothing was
// just added.
export function cancelAddedExperience({
  days,
  experiencesMap,
  lastAddedExperienceId,
  experienceIndexPosition,
}: {
  days: any[] | undefined;
  experiencesMap: Record<string, any> | undefined;
  lastAddedExperienceId: string | null | undefined;
  experienceIndexPosition: number;
}): any[] | null {
  if (!lastAddedExperienceId) {
    return null;
  }

  return [...(days ?? [])].map((d) => {
    const dayExperience = d?.experienceId
      ? experiencesMap?.[d.experienceId]
      : null;
    const isSpreadDay =
      d?.experienceId === lastAddedExperienceId &&
      d?.dayIndex > experienceIndexPosition &&
      d?.dayIndex <
        experienceIndexPosition + (dayExperience?.durationDays || 0);

    return isSpreadDay
      ? {
          ...d,
          experienceId: null,
          hotelId: null,
          experienceDayIndex: null,
          experiencePricing: null,
          hotelPricing: null,
          selectedExtras: [],
        }
      : d;
  });
}
